import { ClientOnly, Link } from '@tanstack/react-router'
import {
  ClipboardListIcon,
  FileTextIcon,
  LayoutTemplateIcon,
  SettingsIcon,
  SparklesIcon,
} from 'lucide-react'

import { useConfig } from '@/components/hooks/use-config'
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from '@/components/ui/navigation-menu'

import { cn } from '@/lib/utils'

const navItems = [
  { to: '/', icon: SparklesIcon, label: 'Tailor Resume' },
  { to: '/log', icon: ClipboardListIcon, label: 'Job Log' },
  { to: '/templates', icon: LayoutTemplateIcon, label: 'Templates' },
  { to: '/settings', icon: SettingsIcon, label: 'Settings' },
]

const LLMConnected = () => {
  const { isConfigured } = useConfig()

  return (
    <div className="ml-1 flex items-center gap-1.5 rounded-full bg-secondary px-2 py-1 sm:ml-4 sm:gap-2 sm:px-3 sm:py-1.5">
      <div
        className={cn(
          'h-2 w-2 rounded-full',
          isConfigured ? 'bg-emerald-500' : 'bg-muted-foreground',
        )}
      />
      <span className="hidden text-xs font-medium text-muted-foreground md:inline">
        {isConfigured ? 'Connected' : 'Not configured'}
      </span>
    </div>
  )
}

export const HeaderBar = () => {
  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur-sm">
      <div className="container mx-auto flex h-14 items-center justify-between gap-2 px-3 sm:h-16 sm:px-4">
        <div className="flex shrink-0 items-center gap-2 sm:gap-3">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary sm:h-9 sm:w-9">
            <FileTextIcon className="h-4 w-4 text-primary-foreground sm:h-5 sm:w-5" />
          </div>
          <div className="xs:flex hidden flex-col">
            <span className="text-base font-semibold tracking-tight sm:text-lg">
              Resume Alpha
            </span>
            <span className="-mt-0.5 hidden text-[10px] font-medium text-muted-foreground sm:block">
              AI-Powered Resume Builder
            </span>
          </div>
        </div>

        <nav className="flex items-center gap-0.5 sm:gap-1">
          <NavigationMenu>
            <NavigationMenuList className="gap-0.5">
              {navItems.map(({ to, icon: Icon, label }) => (
                <NavigationMenuItem key={label}>
                  <NavigationMenuLink
                    className={navigationMenuTriggerStyle()}
                    render={(props) => (
                      <Link
                        {...props}
                        key={to}
                        to={to}
                        className={cn(
                          'flex items-center gap-2 rounded-lg px-2 py-1.5 text-sm font-medium sm:px-3.5 sm:py-2',
                          'text-muted-foreground transition-colors',
                          'hover:bg-secondary hover:text-foreground',
                        )}
                        activeProps={{
                          className: 'bg-secondary text-foreground',
                        }}
                      >
                        <Icon className="h-4 w-4" />
                        <span className="hidden md:inline">{label}</span>
                      </Link>
                    )}
                  ></NavigationMenuLink>
                </NavigationMenuItem>
              ))}
            </NavigationMenuList>
          </NavigationMenu>
          <ClientOnly>
            <LLMConnected />
          </ClientOnly>
        </nav>
      </div>
    </header>
  )
}
